import React from "react";
import { TableContentForCustomerLeafWiseCollection } from '../../../Common/Table/tableContent';
import tokenDecoder from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const total = this.props.total;

        return (
            <div>
                <h3><center><u>Customer Leaf Collection History Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ?
                        "All Routes" : searchData.route}</div>
                    <div className="col"><b>Collection Type: </b> {searchData.collectionType === undefined ?
                        "All Collection Types" : searchData.collectionType}</div>
                    <div className="col"><b>Customer Reg. Number: </b>{(searchData.regNo.length === 0) ?
                        "All Customers" : searchData.regNo}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenDecoder.getUserNameFromToken()}</div>
                    <div className="col"><b>Date: </b> {new Date().toLocaleString()}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="display dataTable no-footer" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>Collected Date</th>
                                        <th>Route Name</th>
                                        <th>Customer Reg. Number</th>
                                        <th>Customer Name</th>
                                        <th>Narration</th>
                                        <th>Collection Type</th>
                                        <th>Bag Count</th>
                                        <th>Gross Amount Total (Kg)</th>
                                        <th>Total Deduction (Kg)</th>
                                        <th>Return Total (Kg)</th>
                                        <th>Net Amount Total (Kg)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForCustomerLeafWiseCollection
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={6}>Total</th>
                                        <th style={{ textAlign: "right" }}>{total.totalBagCount}</th>
                                        <th style={{ textAlign: "right" }}>{total.totalGross}</th>
                                        <th style={{ textAlign: "right" }}>{total.totalDeduction}</th>
                                        <th style={{ textAlign: "right" }}>{total.totalReturn}</th>
                                        <th style={{ textAlign: "right" }}>{total.totalNet}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}